import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import {
  changePasswordResourcePath,
  changePasswordResourceType,
} from "@/modules/auth/api/resources/changePassword/changePasswordConsts";

export function changePasswordMutation(jsonApi: JsonApiClient) {
  return (attributes: { currentPassword: string; newPassword: string }) =>
    jsonApi.createOne({
      type: changePasswordResourceType,
      path: changePasswordResourcePath,
      attributes,
    });
}
